import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../types/errors/common-error-codes';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { OrderDomainError } from '../../errors/order-domain-error';
import { getOrder } from '../../selectors/order/get-order';
import { getOrderPaymentById } from '../../selectors/payments/get-order-payment-by-id';
import { isOrderPaymentRemovable } from '../../utils/order-payment-utils';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
import { registerOrderAction } from '../utils/register-order-action';
export const removeOrderPayment = async (orderPaymentId) => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot remove order payment');
    if (!nonEmptyStringValidator(orderPaymentId, logger.info, 'orderPaymentId')) {
        throw new Error('Cannot remove order payment. Provided orderPaymentId is invalid.');
    }
    const payment = getOrderPaymentById(orderPaymentId);
    if (!payment) {
        throw new OrderDomainError(CommonErrorCodes.InvalidArgument, `Cannot remove order payment. Cannot find order payment with ID '${orderPaymentId}'.`);
    }
    if (!isOrderPaymentRemovable(payment)) {
        throw new Error(`Cannot remove order payment. Order payment type '${payment.type}' is not removable.`);
    }
    const deregisterAction = registerOrderAction('remove-order-payment');
    try {
        await ocapiClient.instance.v1.orders.payments.remove(order.id, orderPaymentId);
        runInAction(() => {
            order.payments = order.payments.filter(p => p.id !== orderPaymentId);
        });
    }
    finally {
        deregisterAction();
    }
};
